export default "__VITE_ASSET__DRjk59AX__"